// extracted by mini-css-extract-plugin
export default {"clarification":"LoginPage_clarification__pP0Qx","link":"LoginPage_link__rsGbB"};